
import React, { useState, useEffect } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselApi } from "@/components/ui/carousel";
import OptimizedImage from "./OptimizedImage";

const mentors = [{
  name: "Bassey Eyo",
  title: "CTO",
  company: "Lybertine",
  image: "/lovable-uploads/bassey-eyo.jpg",
  linkedin: "https://www.linkedin.com/in/eyobassey/"
}, {
  name: "Hatidje Ablyatifova",
  title: "Startup Founder",
  company: "Stanford GSB",
  image: "/lovable-uploads/hatidje-ablyatifova.jpg",
  linkedin: "https://www.linkedin.com/in/hatidje-ablyatifova/"
}, {
  name: "Kirill Osipenko",
  title: "Product Leader",
  company: "Google",
  image: "/lovable-uploads/0c017503-27df-4ee3-b4d5-c262119ec841.png",
  linkedin: "https://www.linkedin.com/in/kirill-osipenko/"
}, {
  name: "Valery Anisimov",
  title: "Compliance",
  company: "Anthropic",
  image: "/lovable-uploads/c85289b6-e23e-49cc-a311-254a4f0d62aa.png",
  linkedin: "https://www.linkedin.com/in/valeryanisimov"
}, {
  name: "Kirill Bobyrev",
  title: "ML Engineer",
  company: "Waymo/Google",
  image: "/lovable-uploads/4d492bc8-0ed9-49a6-94ef-962fe52a633d.png",
  linkedin: "https://www.linkedin.com/in/kirillbobyrev"
}, {
  name: "Sasha Malysheva",
  title: "PhD in AI",
  company: "ex-Google, ex-DeepMind",
  image: "/lovable-uploads/6694eec5-8683-4407-bc8d-55026855367a.png",
  linkedin: "https://www.linkedin.com/in/malysheva-aleksandra/"
}, {
  name: "Artem Shitov",
  title: "ex-Solution Architect",
  company: "Big-3 Consulting",
  image: "/lovable-uploads/920f8360-7bed-4256-9cd8-1d520bad6a80.png",
  linkedin: "https://www.linkedin.com/in/artemshitov/"
}, {
  name: "Fedor Zhdanov",
  title: "Machine Learning Engineer",
  company: "Tenstorrent, ex-Snap",
  image: "/lovable-uploads/f9928361-e5f7-4440-a9ce-14c38d35b92a.png",
  linkedin: "https://www.linkedin.com/in/azever/"
}, {
  name: "Daria Kuk",
  title: "Founder",
  company: "The Ventures",
  image: "/lovable-uploads/059418ca-8700-47b1-a27f-b7d399f4c4b2.png",
  linkedin: "https://www.linkedin.com/in/dariakuk"
}, {
  name: "Vlad Panin",
  title: "General Partner",
  company: "Pulsar Fund",
  image: "/lovable-uploads/927d928e-5b18-420e-bc23-57c25551730a.png",
  linkedin: "https://www.linkedin.com/in/vlad-panin-iframe/"
}, {
  name: "Vlad Vinogradov",
  title: "CTO",
  company: "Optic",
  image: "/lovable-uploads/5f9e5734-1803-4c4c-904b-150d94b57dfb.png",
  linkedin: "https://www.linkedin.com/in/vladvin/"
}, {
  name: "Aliaksei Sala",
  title: "Lead Software Engineer",
  company: "EPAM",
  image: "/lovable-uploads/1db4b5bc-5240-4c7c-885c-8a2f597c1f55.png",
  linkedin: "https://www.linkedin.com/in/aliaksei-sala"
}, {
  name: "Anna Shchehula",
  title: "Growth",
  company: "TRMNL4",
  image: "/lovable-uploads/anna-shchehula.jpg",
  linkedin: "https://www.linkedin.com/in/anna-shchehula/"
}, {
  name: "Nikita Stoletov",
  title: "AI Software Engineer",
  company: "UNOY",
  image: "/lovable-uploads/nikita-stoletov.jpg",
  linkedin: "https://www.linkedin.com/in/nikita-stoletov-30b817292/"
}, {
  name: "Vladislav Terzi",
  title: "Founder",
  company: "Papai Bureau",
  image: "/lovable-uploads/da9bb5d1-e9a4-43fe-98ee-b862f3fd5086.png",
  linkedin: "https://www.linkedin.com/in/terzivladislav/"
}, {
  name: "Irina Rudenko",
  title: "Senior AI Researcher",
  company: "Avride",
  image: "/lovable-uploads/b8b22773-e61a-4ab1-8c12-692df72228f5.png",
  linkedin: "https://www.linkedin.com/in/irina-rud/"
}, {
  name: "Igor Kulatov",
  title: "Chief Software Architect",
  company: "IBS Tech",
  image: "/lovable-uploads/igor-kulatov.jpg",
  linkedin: "https://www.linkedin.com/in/kulatov/"
}, {
  name: "Stepan Fedorov",
  title: "SRE Team Lead",
  company: "ex-Unlimint",
  image: "/lovable-uploads/stepan-fedorov.jpg",
  linkedin: "https://www.linkedin.com/in/sfatgc/"
}, {
  name: "Ruslan Malsagov",
  title: "Quantitative Researcher/Trading Lead",
  company: "Flow Traders",
  image: "/lovable-uploads/kyrylo-kupin.jpg",
  linkedin: "https://www.linkedin.com/in/ruslan-malsagov/"
}, {
  name: "Kyrylo Kupin",
  title: "Chief Manufacturing Officer",
  company: "Sizl",
  image: "/lovable-uploads/kyrylo-kupin-new.jpg",
  linkedin: "https://www.linkedin.com/in/kyrylo-kupin-542953254/"
}, {
  name: "Vlad Yanch",
  title: "CEO",
  company: "Agentplace.io",
  image: "/lovable-uploads/vlad-yanch.jpg",
  linkedin: "https://www.linkedin.com/in/vlad-yanch/"
}, {
  name: "Oleksii Popov",
  title: "Serial Entrepreneur",
  company: "",
  image: "/lovable-uploads/oleksii-popov-new.jpg",
  linkedin: "https://www.linkedin.com/in/oleksii-popov/"
}];

const MentorCard = React.memo(({ mentor }: { mentor: typeof mentors[0] }) => (
  <a 
    href={mentor.linkedin}
    target="_blank"
    rel="noopener noreferrer"
    className="block relative overflow-hidden rounded-2xl aspect-square group cursor-pointer md:hover:scale-105 transition-transform duration-300"
    style={{
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
      backgroundImage: `linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0.2), transparent), url(${mentor.image})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}
  >
    <div className="absolute bottom-0 left-0 right-0 p-3">
      <h3 className="text-base font-semibold mb-1 text-white">
        {mentor.name}
      </h3>
      <p className="text-xs text-white/90 mb-1">
        {mentor.title}
      </p>
      <p className="text-xs text-white/80">
        {mentor.company}
      </p>
    </div>
  </a>
));
MentorCard.displayName = "MentorCard";

const OurMentors = () => {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);

  return <section id="mentors" style={{
    backgroundColor: '#F2F3EE'
  }} className="w-full m-0 p-0 py-12 sm:py-16 md:py-20">
      <div style={{
      backgroundColor: '#F2F3EE'
    }} className="container px-4 sm:px-6 lg:px-8 mx-auto">
        {/* Centered header with badge */}
        <div className="flex justify-center mb-8 sm:mb-16">
          <div className="inline-flex items-center justify-center px-4 py-2 rounded-full" style={{
          backgroundColor: 'rgba(242, 76, 39, 0.1)',
          border: '1px solid rgba(242, 76, 39, 0.2)',
          color: 'rgba(242, 76, 39, 1)'
        }}>
            <span style={{
            backgroundColor: 'rgba(242, 76, 39, 1)'
          }} className="inline-flex items-center justify-center w-5 h-5 rounded-full text-white mr-2 text-sm">5</span>
            <span>Our Jury & Mentors</span>
          </div>
        </div>
        
        {/* Section heading */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold mb-4 pb-2" style={{
          background: 'linear-gradient(135deg, rgba(242, 76, 39, 1) 0%, rgba(31, 31, 30, 1) 100%)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          color: 'transparent'
        }}>
            <span className="hidden md:inline">Learn from Industry Leaders</span>
            <span className="md:hidden">Industry Leaders</span>
          </h2>
          <p className="text-lg" style={{
          color: 'rgba(77, 77, 77, 1)'
        }}>
            Get guidance from top AI experts and industry veterans
          </p>
        </div>
        
        {/* Desktop grid - 22 mentors in 6-6-6-4 layout */}
        <div className="hidden lg:block mb-16 max-w-7xl mx-auto">
          <div className="flex justify-center gap-5 mb-5">
            {mentors.slice(0, 6).map(mentor => (
              <div key={mentor.name} className="w-44">
                <MentorCard mentor={mentor} />
              </div>
            ))}
          </div>
          <div className="flex justify-center gap-5 mb-5">
            {mentors.slice(6, 12).map(mentor => (
              <div key={mentor.name} className="w-44">
                <MentorCard mentor={mentor} />
              </div>
            ))}
          </div>
          <div className="flex justify-center gap-5 mb-5">
            {mentors.slice(12, 18).map(mentor => (
              <div key={mentor.name} className="w-44">
                <MentorCard mentor={mentor} />
              </div>
            ))}
          </div>
          <div className="flex justify-center gap-5">
            {mentors.slice(18, 22).map(mentor => (
              <div key={mentor.name} className="w-44">
                <MentorCard mentor={mentor} />
              </div>
            ))}
          </div>
        </div>

        {/* Tablet - carousel instead of grid */}
        <div className="hidden"></div>

        {/* Mobile carousel - visible only on mobile */}
        <div className="lg:hidden mb-16 w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw]">
          <Carousel setApi={setApi} className="w-full" opts={{
          align: "center",
          loop: true
        }}>
            <CarouselContent className="-ml-2">
              {mentors.map(mentor => <CarouselItem key={mentor.name} className="basis-4/5 md:basis-2/3 pl-2">
                  <MentorCard mentor={mentor} />
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>
          
          {/* Dots navigation */}
          <div className="flex justify-center space-x-2 mt-6">
            {Array.from({
            length: count
          }).map((_, index) => <button key={index} className={`w-2 h-2 rounded-full transition-all duration-200 ${index + 1 === current ? 'bg-orange-500 w-6' : 'bg-gray-300'}`} onClick={() => api?.scrollTo(index)} />)}
          </div>
        </div>
      </div>
    </section>;
};

export default OurMentors;
